import React, { useContext } from 'react';
import dayjs from 'dayjs';
import { TReportField } from '@@config/report';
import { LocaleContext, TLocaleContext } from '@@contexts/LocaleContext';
import { getLocaleDayJS } from '@@utils/utils.ts';

type TReportBasicInfoProps = {
    readonly reportNumber: TReportField;
    readonly reportDate: TReportField;
};

const ReportBasicInfo: React.FC<TReportBasicInfoProps> = ({ reportNumber, reportDate }) => {
    const { locale }: TLocaleContext = useContext(LocaleContext);
    const reportDateFormatted = dayjs(reportDate.VALUE).locale(getLocaleDayJS(locale)).format('MMM. D, YYYY');

    return (
        <div className='report-basic-info flex mb-2 lg:mb-0'>
            <div className='flex flex-col'>
                <h3 className='m-0 p-0 uppercase'>{reportNumber.LABEL}</h3>
                <p id='REPORT_NO' className='mt-1 md:mt-2'>
                    {reportNumber.VALUE}
                </p>
            </div>
            <div className='flex flex-col'>
                <h3 className='m-0 p-0 uppercase text-right md:text-left'>{reportDate.LABEL}</h3>
                <p id='REPORT_DT' className='mt-1 md:mt-2 text-right md:text-left'>
                    {reportDateFormatted}
                </p>
            </div>
        </div>
    );
};

export default ReportBasicInfo;
export type { TReportBasicInfoProps };
